export default __webpack_public_path__ + "static/media/Dice-1.2eb036fc.png";